import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let AccessTypeComponent = {
    selector: "vcAccessType",
    templateUrl: "/angular/components/building/access-type.component.html",
    bindings: {
        selectedAccessType: "=",
    },
    controller: class AccessTypeController {
        // * bindings for typescript compiler *
        public selectedAccessType: any;
        // ************************************

        public accessTypes: string[] = ["locked", "unlocked", "unspecified"];
        public accessType: string | number;
        private dialog: DialogUtils;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        $onInit() {
            this.accessType = this.selectedAccessType;
        }

        confirm(): void {
            this.dialog.hide(this.accessType);
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("building", [])
    .component(AccessTypeComponent.selector, AccessTypeComponent);
